import React, { Component } from "react";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { Link } from "react-router-dom";

import { ProjectService } from "app/_services/ProjectService/ProjectService";
import {
  Dropdown,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  TabContent,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { IoIosArrowRoundForward } from "react-icons/io";
import { GrAttachment } from "react-icons/gr";
import DateTime from "react-datetime";
import { SupportService } from "app/_services/Support/supportService";
import { UserService } from "app/_services/UserService/UserService";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { mdyDateFormat, chatDateFormat } from "app/_helpers/helper";
import { connect } from "react-redux";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import {
  BsFileEarmarkArrowDown,
  BsFileEarmarkArrowUp,
  BsGraphDown,
} from "react-icons/bs";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import ReactDOM from "react-dom";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { tostor } from "toastr";
import {
  HO_Work_Flow_Role_List,
  RO_Work_Flow_Role_List,
  MINE_Work_Flow_Role_List,
} from "app/_constants/constant.js";
import LocationHistoryList from "../UserManagement/Employee/Component/LocationHistoryList";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import moment from "moment";
import SupportHistoryTable from "../UserManagement/Employee/Component/SupportHistoryTable";
import EvidencePreview from "../_healthSafetyEnvironment/IncidentManagement/EvidencePreview";
import BackBtn from "app/Components/CommanComponents/BackBtn";
class TicketView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      supportId: this.props.match.params.sId ? this.props.match.params.sId : "",
      SupportData: "",
      userList: [],
      userData: "",
      roleLabel: "",
      superadmin: "1",
      isClosed: "",
      closed: "",
      assignedTo: "",
      comments: "",
      resolution: "",
      resolutionDateTime: null,
      resolvedBy: "",
      message: "",
      chatList: [],
      // startTicketClicked: false,
      ticketStatus: false,
      closedClicked: false,
      reassignClicked: false,
      anyOfTwoBtnClickedClosedReassigned: false,
      commentsReassigned: "",
      commentsClosed: "",
      ticketStatusRawValue: "",
      errorForm: {},
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
  }
  handleSubmittedOrInprogress = () => {};
  componentDidMount() {
    this.loggedUser();
    this.setUsers();
    this.setChat();
    this.setSupportData(this.state.supportId);
    this.scrollToBottom();
    this.handleSubmittedOrInprogress();

    // console.log("sdfdsfdsffdsf", TOTAL_ROLE_LIST_VIEW);
  }
  ticketHistory = async () => {
    //   console.log("qqqqqqqqqqqqqqqqqqq", this.state);
    try {
      let response = await SupportService.ticketHistory({
        comment: this.state.commentsReassigned,
        ticketId: this.state.SupportData.id,
        assignedTo: this.state.assignedTo,
        assignedBy: this.props.user.user.id,
        ticketStatus: this.state.ticketStatusRawValue,
      });
      //console.log("responseTicketHistory", response);
    } catch {
      console.log("error");
    }

    this.setState({
      commentsReassigned: "",
    });
    //  console.log("qqqq2", this.state);
  };
  scrollToBottom = () => {
    if (this.state.ticketStatus) return;
    const messagesContainer = ReactDOM.findDOMNode(this.messagesContainer);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  };
  updateInfoForClose = async () => {
    try {
      let response = await SupportService.updateSupport(this.state.supportId, {
        ticketStatus: "closed",
        comment: this.state.commentsClosed,
        closedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        closedBy: this.props.user.user.id,
      });
      console.log("this is response from CLosed", response);
      toastr.success(response.message);
      this.setState({ commentsClosed: "" });
      this.props.history.push("/support");
    } catch (error) {
      console.log(error);
    }

    this.setState({ commentsClosed: "" });
    this.props.history.push("/support");

    // console.log("let", response);
    // if (response && response.status) {
    //   if (response.data) {
    //     let SupportData = response.data;
    //     this.setState({
    //       ticketStatus: SupportData.ticketStatus === "submitted" ? true : false,
    //       SupportData: SupportData,
    //       isClosed: SupportData.isClosed,
    //       closed: SupportData.isClosed,
    //       assignedTo: SupportData.assignedTo,
    //       comments: SupportData.comments,
    //       resolution: SupportData.resolution,
    //       resolutionDateTime: SupportData.resolutionDateTime
    //         ? mdyDateFormat(SupportData.resolutionDateTime)
    //         : null,
    //       resolvedBy: SupportData.resolvedByUser
    //         ? SupportData.resolvedByUser.firstName +
    //           " " +
    //           SupportData.resolvedByUser.lastName
    //         : "",
    //     });
    //   }
    // } else {
    // }
  };

  updateInfoForReassign = async () => {
    console.log("updateInfoForReassign", this.state);
    const errObj = {};
    if (!this.state?.assignedTo) {
      errObj["assignedTo"] = "Assigned To is required";
    }
    this.setState((prev) => ({ ...prev, errorForm: errObj }));

    if (Object.values(errObj)?.filter((d) => d !== "")?.length) return;
    try {
      let response = await SupportService.updateSupport(
        this.state.supportId,

        {
          ticketStatus: "reassigned",
          comment: this.state.commentsReassigned,
          assignedTo: this.state.assignedTo,
        },
        this.props.user.user.id
      );
      if (response) this.ticketHistory();
      console.log("yesThis", response);
      toastr.success(response.message);
      this.setState({ commentsReassigned: "" });
      this.props.history.push("/support");
    } catch (error) {
      console.log(error);
    }

    // console.log("let", response);
    // if (response && response.status) {
    //   if (response.data) {
    //     let SupportData = response.data;
    //     this.setState({
    //       ticketStatus: SupportData.ticketStatus === "submitted" ? true : false,
    //       SupportData: SupportData,
    //       isClosed: SupportData.isClosed,
    //       closed: SupportData.isClosed,
    //       assignedTo: SupportData.assignedTo,
    //       comments: SupportData.comments,
    //       resolution: SupportData.resolution,
    //       resolutionDateTime: SupportData.resolutionDateTime
    //         ? mdyDateFormat(SupportData.resolutionDateTime)
    //         : null,
    //       resolvedBy: SupportData.resolvedByUser
    //         ? SupportData.resolvedByUser.firstName +
    //           " " +
    //           SupportData.resolvedByUser.lastName
    //         : "",
    //     });
    //   }
    // } else {
    // }
  };

  componentDidUpdate() {
    this.scrollToBottom();
  }
  startTicketFunction = async () => {
    let response = await SupportService.updateSupport(
      this.state.supportId,
      {
        ticketStatus: "inProgress",
        startedBy: this.props.user.user.id,
        startedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      this.props.user.user.id
    );
    console.log("let", response);
    if (response && response.status) {
      if (response.data) {
        let SupportData = response.data;

        this.setState((prev) => ({
          ...prev,
          ticketStatus: SupportData.ticketStatus === "submitted" ? true : false,
          SupportData: {
            ...SupportData,
            createdByUser: prev?.SupportData?.createdByUser,
            // startedByUser: prev?.SupportData?.startedByUser,
          },
          isClosed: SupportData.isClosed,
          closed: SupportData.isClosed,
          assignedTo: SupportData.assignedTo,

          comments: SupportData.comments,
          resolution: SupportData.resolution,
          resolutionDateTime: SupportData.resolutionDateTime
            ? mdyDateFormat(SupportData.resolutionDateTime)
            : null,
          resolvedBy: SupportData.resolvedByUser
            ? SupportData.resolvedByUser.firstName +
              " " +
              SupportData.resolvedByUser.lastName
            : "",
        }));
      }
    } else {
    }
  };
  scrollToBottom() {
    this.el.scrollIntoView({ behavior: "smooth" });
  }
  /*******************Api Call *******************/
  async loggedUser() {
    let response = await UserService.loggedUser();

    if (response && response.status) {
      this.setState({
        userData: response?.data?.id,
        roleLabel: response?.data?.role?.roleLable,
      });
    }
    this.checkuser(this.state.userData);
  }

  async checkuser(data) {
    if (this.state.userData != "") {
      const response = await CommmonService.userCheck(data);
      //   if (!response?.status) return toastr.error(response?.message);
      this.setState({
        superadmin: response,
      });
    }
  }
  async setUsers() {
    let response = await UserService.getUsers();
    if (response && response.status && response.data) {
      this.setState({
        userList: response.data,
      });
    } else {
      this.setState({
        userList: [],
      });
    }
  }

  async setChat() {
    let response = await SupportService.getChatBySupportID(this.state.supportId);

    if (response && response.status && response.data) {
      this.setState({
        chatList: response.data,
      });
    } else {
      this.setState({
        chatList: [],
      });
    }
  }
  async setSupportData(id) {
    console.log("runningSupportData");
    let response = await SupportService.getSupportByID(id);
    // console.log("anmol", response);
    // if(response && response.ticketStatus==="submitted") this.setState({ticketStatus:true});
    // else if(response && response.ticketStatus==="inprogress") this.setState({ticketStatus:false})
    if (response && response.status) {
      if (response.data) {
        let SupportData = response.data;
        // console.log("anmol");
        //SupportData.ticketStatus = "inProgress";
        //SupportData.ticketStatus = "closed";
        // SupportData.ticketStatus = "submitted";

        //    SupportData.ticketStatus = "reassigned";
        this.setState({
          ticketStatus: SupportData.ticketStatus === "submitted" ? true : false,
          ticketStatusRawValue: SupportData.ticketStatus,
          SupportData: SupportData,
          isClosed: SupportData.isClosed,
          closed: SupportData.isClosed,
          assignedTo: SupportData.assignedTo,
          comments: SupportData.comments,
          resolution: SupportData.resolution,
          resolutionDateTime: SupportData.resolutionDateTime
            ? mdyDateFormat(SupportData.resolutionDateTime)
            : null,
          resolvedBy: SupportData.resolvedByUser
            ? SupportData.resolvedByUser.firstName +
              " " +
              SupportData.resolvedByUser.lastName
            : "",
        });
      }
      //  console.log("jam", this.state.SupportData.ticketStatus);
    } else {
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onChangeHandler = async ({ target }) => {
    const extensions = ["jpg", "jpeg", "png", "mp4", "pdf"];
    const file = target.files[0];
    const path = URL.createObjectURL(target.files[0]);
    console.log("File path", file);
    target.value = null;

    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();

    if (!extensions.includes(extension))
      return toastr.warning(
        `Only ${extensions.map((ext) => ext.toUpperCase()).join(", ")} file(s) allowed!`
      );

    // this.setState({ loading: true });
    const formData = new FormData();

    formData.append("file", file);

    const response = await CommmonService.uploadDocument(formData);
    // this.setState({ loading: false });

    if (!response?.status) return toastr.error(response?.message);

    if (response && response.data) {
      let type = "";
      if (response.data.extenstion === ".mp4") {
        type = "video";
      }
      this.setState({
        fileResponse: { file: response.data, type: type },
      });

      if (response.data.extenstion === ".pdf") {
        type = "document";
        this.setState({
          fileResponse: { size: 25, file: response.data, type: type },
        });
      }

      // this.setState({
      //   fileResponse: response.data,
      // });
      console.log("fileResponse", this.state.fileResponse);
      // onChangeFile({ file }, response.data);
    }
  };

  onChangeHandler = async ({ target }) => {
    const extensions = ["jpg", "jpeg", "png", "mp4", "pdf"];
    const file = target.files[0];
    const path = URL.createObjectURL(target.files[0]);
    console.log("File path", file);
    target.value = null;

    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();

    if (!extensions.includes(extension))
      return toastr.warning(
        `Only ${extensions.map((ext) => ext.toUpperCase()).join(", ")} file(s) allowed!`
      );

    // this.setState({ loading: true });
    const formData = new FormData();

    formData.append("file", file);

    const response = await CommmonService.uploadDocument(formData);
    // this.setState({ loading: false });

    if (!response?.status) return toastr.error(response?.message);

    if (response && response.data) {
      let type = "";
      if (response.data.extenstion === ".mp4") {
        type = "video";
      }
      this.setState({
        fileResponse: { file: response.data, type: type },
      });

      if (response.data.extenstion === ".pdf") {
        type = "document";
        this.setState({
          fileResponse: { size: 25, file: response.data, type: type },
        });
      }

      // this.setState({
      //   fileResponse: response.data,
      // });
      console.log("fileResponse", this.state.fileResponse);
      // onChangeFile({ file }, response.data);
    }
  };

  sendMessage = async (e) => {
    e.preventDefault();
    if (this.state.supportId) {
      let obj = {
        documents: this.state.fileResponse?.file,
        supportId: this.state.supportId,
        message: this.state.message,
        messtype: "messtype",
        userId: 1,
      };

      let response = await SupportService.createChat(this.state.supportId, obj);
      if (response && response.status && response.data) {
        this.setState({
          message: "",
          fileResponse: "",
        });
        this.setChat();
      } else {
        this.setState({
          message: [],
        });
      }
    } else {
    }
  };
  sendMessageTwo = async () => {
    if (this.state.supportId) {
      let obj = {
        supportId: this.state.supportId,
        message: "Acknowledged Ticket",
        messtype: "messtype",
        userId: 1,
      };

      let response = await SupportService.createChat(this.state.supportId, obj);
      if (response && response.status && response.data) {
        this.setState({
          message: "",
        });
        this.setChat();
      } else {
        this.setState({
          message: [],
        });
      }
    } else {
    }
  };
  /**********************Form submit ***************/

  async onSubmit(e) {
    e.preventDefault();

    const { assignedTo, isClosed, comments, resolution, resolvedBy } = this.state;

    let formDataObj = {
      isClosed: isClosed,
      assignedTo: assignedTo,
      comments: comments,
      resolution: isClosed == 1 ? comments : "",
      resolutionDateTime: isClosed == 1 ? new Date() : null,
      resolvedBy: resolvedBy,
    };
    // console.log("/**/*/*/", formDataObj);
    // return;
    let data = await SupportService.closeSupport(this.state.supportId, formDataObj);

    if (data && data.status) {
      toastr.success("Ticket Status Updated");
      this.props.history.push("/support");
    } else if (data && data.message) {
      toastr.warning(data.message);
    }
  }

  render() {
    const {
      userList,
      assignedTo,
      isClosed,
      comments,
      resolution,
      resolvedBy,
      SupportData,
      resolutionDateTime,
      message,
      chatList,
    } = this.state;

    const { createdByUser } = SupportData;
    // console.log("state", this.state);
    // console.log("createdByUser?.id", createdByUser?.id);
    // console.log("userList", userList);

    let userPermissions = JSON.parse(localStorage.getItem("userPermissions"));

    return (
      <div>
        <MainBreadcrumb
          routeSegments={[{ name: "Support", path: "/support" }, { name: "Ticket View" }]}
          breadCrumbsText="Support"
        />

        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">
                    {" "}
                    Ticket Number -{" "}
                    {this.state.SupportData && "#" + this.state.SupportData.ticket_no}
                    <span style={{ marginLeft: "45rem" }}>
                      {" "}
                      {!this.state.ticketStatus ||
                      (this.state.roleLabel !== 6 && this.state.roleLabel !== 1) ? (
                        <></>
                      ) : (
                        <button
                          className="btn btn-primary ml-2"
                          onClick={() => {
                            this.startTicketFunction();
                            this.sendMessageTwo("Acknowledged Ticket");
                          }}
                        >
                          Start Ticket
                        </button>
                      )}
                      {/* <BackBtn url={"/support"} /> */}
                    </span>
                  </h3>
                </div>
                {!this.state.ticketStatus ? (
                  <Row className="mb-5">
                    <Col md={6}>
                      <div className="ticketDetailsInfo">
                        <Row>
                          <Col md={4} className="drilingView-bx">
                            <h5>Ticket No.</h5>
                            <p>
                              {this.state.SupportData && this.state.SupportData.ticket_no}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Date & Time</h5>
                            <p>
                              {this.state.SupportData &&
                                chatDateFormat(this.state.SupportData.ticket_date)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Section</h5>
                            <p>
                              {this.state.SupportData && this.state.SupportData.section}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Sub Section</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.subSection}
                            </p>
                          </Col>
                          {/* <Col md={4} className="drilingView-bx">
                          <h5>Module</h5>
                          <p>
                            {this.state.SupportData && this.state.SupportData.module_name}
                          </p>
                        </Col> */}
                          {/* <Col md={4} className="drilingView-bx">
                          <h5>Sub Modules</h5>
                          <p>
                            {this.state.SupportData &&
                              this.state.SupportData.submodule_name}
                          </p>
                        </Col> */}
                          <Col md={4} className="drilingView-bx">
                            <h5>Reported By</h5>
                            <p>
                              {createdByUser
                                ? createdByUser.firstName + " " + createdByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Ticket Status</h5>
                            <p>
                              {this.state.SupportData &&
                              this.state.SupportData.ticketStatus === "closed"
                                ? "Closed"
                                : this.state.SupportData.ticketStatus === "reassigned"
                                ? "Re-assigned"
                                : this.state.SupportData.ticketStatus === "submitted"
                                ? "Submitted"
                                : this.state.SupportData.ticketStatus === "inProgress"
                                ? "In Progress"
                                : "Re-Opened"}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Started By</h5>
                            <p>
                              {this.state.SupportData?.startedByUser
                                ? this.state.SupportData.startedByUser.firstName +
                                  " " +
                                  this.state.SupportData.startedByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Closed By</h5>
                            <p>
                              {this.state.SupportData?.closedByUser
                                ? this.state.SupportData.closedByUser.firstName +
                                  " " +
                                  this.state.SupportData.closedByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Started At</h5>
                            <p>
                              {this.state.SupportData?.startedAt &&
                                chatDateFormat(this.state.SupportData.startedAt)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Closed At</h5>
                            <p>
                              {this.state.SupportData?.closedAt &&
                                chatDateFormat(this.state.SupportData.closedAt)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Role</h5>
                            <p>
                              {createdByUser
                                ? createdByUser.role.title
                                  ? createdByUser.role.title
                                  : ""
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Site Type</h5>
                            <p>{createdByUser ? createdByUser.role.siteType : ""}</p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Priority</h5>
                            <p>
                              {this.state.SupportData &&
                                (this.state.SupportData.priority == 3
                                  ? "High"
                                  : this.state.SupportData.priority == 2
                                  ? "Medium"
                                  : "Low")}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Issue Summary</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.issue_summary}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Issue Description</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.issue_description}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Url From</h5>
                            <p>{SupportData.urlFrom ? SupportData.urlFrom : ""}</p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Attachments</h5>
                            <div className="attachedFile-bx">
                              {SupportData &&
                                SupportData.documents_table_mappings &&
                                SupportData.documents_table_mappings.map((element) => {
                                  if (element.document) {
                                    return (
                                      <p>
                                        <span>{element.document.alias}</span>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id="tooltip-top">
                                              {" "}
                                              {element.document.real_document_name}
                                            </Tooltip>
                                          }
                                        >
                                          <a
                                            href={
                                              URL_CONFIG.IMG_URL +
                                              element.document.document_name
                                            }
                                            target="_blank"
                                            className="icons text-cyanBlue"
                                            style={{ textAlign: "center" }}
                                          >
                                            <BsFileEarmarkArrowDown size="16" />
                                          </a>
                                        </OverlayTrigger>
                                      </p>
                                    );
                                  }
                                })}
                            </div>
                          </Col>
                          {/* {userList && Array.isArray(userList) && userList.length > 0
                          ? userList.map((userData, index) => {
                              return userData.id === reportedByUser.id
                                ? userData.accessPermissions.map(
                                    (accessPermission, index) => {
                                      return (
                                        <>
                                          <Col md={4} className="drilingView-bx">
                                            <h5>{accessPermission.permission}</h5>
                                            <p>
                                              {accessPermission.permissionValue == 1
                                                ? "YES"
                                                : "NO"}
                                            </p>
                                          </Col>
                                        </>
                                      );
                                    }
                                  )
                                : "";
                            })
                          : ""} */}
                          {this.state.superadmin == 0 ? (
                            <Col md={4} className="drilingView-bx">
                              <h5>Role Permission</h5>
                              <p>
                                {userList
                                  ?.find((userData) => userData?.id === createdByUser?.id)
                                  ?.accessPermissions?.filter(
                                    (d) => +d.permissionValue === 1
                                  )
                                  .map((d) => {
                                    if (createdByUser.role.siteType == 3) {
                                      return MINE_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    } else if (createdByUser.role.siteType == 2) {
                                      return RO_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    } else if (createdByUser.role.siteType == 1) {
                                      return HO_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    }
                                  })
                                  .join(", ")}
                              </p>
                            </Col>
                          ) : (
                            <></>
                          )}
                        </Row>
                        {this.state.superadmin == 0 ? (
                          <React.Fragment>
                            <div className="">
                              {/* <h4>Close this ticket </h4> */}
                              {/* <button
                                className="toggleTicketForm"
                                onClick={() => {
                                  this.setState({ show: !this.state.show });
                                }}
                              >
                                {this.state.show ? "Hide" : "Show"} Form
                              </button> */}
                              {/* <button
                                className="btn btn-primary ml-2"
                                style={{ marginLeft: "20px" }}
                              >
                                Update
                              </button>
                              <button className="btn btn-primary ml-2">Update2</button> */}
                              {this.state?.SupportData?.ticketStatus === "inProgress" &&
                                (this.state?.SupportData?.createdBy ===
                                  this.props.user.user.id ||
                                  this.state?.SupportData?.startedBy ===
                                    this.props.user.user.id ||
                                  this.state.roleLabel === 1) && (
                                  <div className="row">
                                    <div className="col-md-12 pt-1 pb-4 text-center">
                                      {this.state.anyOfTwoBtnClickedClosedReassigned ? (
                                        <></>
                                      ) : (
                                        <button
                                          // to={"/support"}
                                          // className="btn btn-secondary mr-2"
                                          className="btn btn-primary ml-2"
                                          onClick={() => {
                                            this.setState({
                                              closedClicked: !this.state.closedClicked,
                                              isClosed: 1,
                                            });
                                            this.setState({
                                              anyOfTwoBtnClickedClosedReassigned: true,
                                            });
                                          }}
                                        >
                                          Close
                                        </button>
                                      )}
                                      {this.state.anyOfTwoBtnClickedClosedReassigned ? (
                                        <></>
                                      ) : (
                                        <button
                                          className="btn btn-primary ml-2"
                                          onClick={() => {
                                            this.setState({
                                              reassignClicked:
                                                !this.state.reassignClicked,
                                              anyOfTwoBtnClickedClosedReassigned: true,
                                              isClosed: 3,
                                            });
                                            // this.setState({
                                            //   anyOfTwoBtnClickedClosedReassigned: true,
                                            // });
                                            // this.setState({
                                            //   isClosed: 1,
                                            // });
                                          }}
                                        >
                                          Reassign
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                              {(this.state?.SupportData?.ticketStatus === "reassigned" ||
                                this.state?.SupportData?.ticketStatus === "reOpened") &&
                                (this.state?.SupportData?.assignedTo ===
                                  this.props.user.user.id ||
                                  this.state?.SupportData?.createdBy ===
                                    this.props.user.user.id ||
                                  this.state.roleLabel === 1) && (
                                  <div className="row">
                                    <div className="col-md-12 pt-1 pb-4 text-center">
                                      {this.state.anyOfTwoBtnClickedClosedReassigned ? (
                                        <></>
                                      ) : (
                                        <button
                                          // to={"/support"}
                                          // className="btn btn-secondary mr-2"
                                          className="btn btn-primary ml-2"
                                          onClick={() => {
                                            this.setState({
                                              closedClicked: !this.state.closedClicked,
                                              isClosed: 1,
                                            });
                                            this.setState({
                                              anyOfTwoBtnClickedClosedReassigned: true,
                                            });
                                          }}
                                        >
                                          Close
                                        </button>
                                      )}
                                      {this.state.anyOfTwoBtnClickedClosedReassigned ? (
                                        <></>
                                      ) : (
                                        <button
                                          className="btn btn-primary ml-2"
                                          onClick={() => {
                                            this.setState({
                                              reassignClicked:
                                                !this.state.reassignClicked,
                                              anyOfTwoBtnClickedClosedReassigned: true,
                                              isClosed: 3,
                                            });
                                            // this.setState({
                                            //   anyOfTwoBtnClickedClosedReassigned: true,
                                            // });
                                            // this.setState({
                                            //   isClosed: 1,
                                            // });
                                          }}
                                        >
                                          Reassign
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div></div>

                            {this.state.closedClicked ? (
                              <form onSubmit={this.onSubmit}>
                                <div className="row">
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Status</label>
                                    <select
                                      name="isClosed"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={this.state.isClosed}
                                      defaultValue={1}
                                      disabled={this.state.isClosed === 1}
                                      //  required
                                    >
                                      <option value={2}>Not Started</option>
                                      <option value={3}>Acknowledged</option>
                                      <option value={1}>Close</option>
                                      <option hidden value={4}>
                                        Reopened
                                      </option>
                                    </select>
                                  </div>
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Assigned To</label>

                                    <select
                                      name="assignedTo"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={assignedTo}
                                      disabled={true}
                                      //required
                                    >
                                      <option value="">Select User</option>

                                      {userList &&
                                      Array.isArray(userList) &&
                                      userList.length > 0
                                        ? userList.map((userData, index) => {
                                            // console.log("console.log,userData", userData);
                                            return userData?.role?.roleLable === 6 ? (
                                              <option key={index} value={userData.id}>
                                                {userData?.firstName +
                                                  " " +
                                                  userData?.lastName}
                                              </option>
                                            ) : (
                                              ""
                                            );
                                          })
                                        : ""}
                                    </select>
                                  </div>
                                </div>
                                <div className="row">
                                  {
                                    <div className="col-sm-12 form-group mb-3">
                                      <label> Close Comments (for support Team) </label>
                                      <input
                                        name="commentsClosed"
                                        type="text"
                                        placeholder="Add comments"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={this.state.commentsClosed}
                                        // readOnly={SupportData.isClosed == 1}
                                      />
                                    </div>
                                  }
                                </div>
                                {this.state.closed == 1 && (
                                  <React.Fragment>
                                    <div className="row">
                                      {/* <div className="col-md-12 form-group mb-3">
                                        <label>Resolution</label>
                                        <textarea
                                          name="resolution"
                                          placeholder="xyz"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolution}
                                          readOnly
                                        ></textarea>
                                      </div> */}
                                    </div>
                                    <div className="row">
                                      {/* <div className="col-sm-6 form-group mb-3 datePickerUp">
                                        <label>Date and Time of Resolution</label>

                                        <input
                                          name="resolutionDateTime"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolutionDateTime}
                                          readOnly
                                        />
                                      </div> */}
                                      {/* <div class Name="col-sm-6 form-group mb-3">
                                        <label>Resolved By</label>
                                        <input
                                          name="resolvedBy"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolvedBy}
                                          readOnly
                                        />
                                      </div> */}
                                    </div>
                                  </React.Fragment>
                                )}
                                {
                                  <div className="row">
                                    <div className="col-md-12 pt-1 pb-4 text-center">
                                      <Link
                                        to={"/support"}
                                        className="btn btn-secondary mr-2"
                                      >
                                        Back
                                      </Link>
                                      <button
                                        type="button"
                                        className="btn btn-primary ml-2"
                                        onClick={() => {
                                          this.updateInfoForClose();
                                        }}
                                      >
                                        Close
                                      </button>
                                    </div>
                                  </div>
                                }
                              </form>
                            ) : null}
                            {
                              //799
                              this.state.SupportData.ticketStatus === "closed" && (
                                <form onSubmit={this.onSubmit}>
                                  <div className="row">
                                    <div className="col-sm-6 form-group mb-3">
                                      <label>Status</label>
                                      <select
                                        name="isClosed"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={1}
                                        defaultValue={1}
                                        disabled={true}
                                        //  required
                                      >
                                        <option value={2}>Not Started</option>
                                        <option value={3}>Acknowledged</option>
                                        <option value={1}>Close</option>
                                        <option hidden value={4}>
                                          Reopened
                                        </option>
                                      </select>
                                    </div>
                                    <div className="col-sm-6 form-group mb-3">
                                      <label>Assigned To</label>

                                      <select
                                        name="assignedTo"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={assignedTo}
                                        disabled={true}
                                        //required
                                      >
                                        <option value="">Select User</option>

                                        {userList &&
                                        Array.isArray(userList) &&
                                        userList.length > 0
                                          ? userList.map((userData, index) => {
                                              // console.log("console.log,userData", userData);
                                              return userData?.role?.roleLable === 6 ? (
                                                <option key={index} value={userData.id}>
                                                  {userData?.firstName +
                                                    " " +
                                                    userData?.lastName}
                                                </option>
                                              ) : (
                                                ""
                                              );
                                            })
                                          : ""}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row">
                                    {
                                      <div className="col-sm-12 form-group mb-3">
                                        <label> Close Comments (for support Team) </label>
                                        <input
                                          name="commentsClosed"
                                          type="text"
                                          placeholder="Add comments"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={this.state.comments}
                                          disabled={
                                            this.state.SupportData.ticketStatus ===
                                            "closed"
                                          }
                                          // readOnly={SupportData.isClosed == 1}
                                        />
                                      </div>
                                    }
                                  </div>
                                  {this.state.closed == 1 && (
                                    <React.Fragment>
                                      <div className="row">
                                        {/* <div className="col-md-12 form-group mb-3">
                                      <label>Resolution</label>
                                      <textarea
                                        name="resolution"
                                        placeholder="xyz"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={resolution}
                                        readOnly
                                      ></textarea>
                                    </div> */}
                                      </div>
                                      <div className="row">
                                        {/* <div className="col-sm-6 form-group mb-3 datePickerUp">
                                      <label>Date and Time of Resolution</label>

                                      <input
                                        name="resolutionDateTime"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={resolutionDateTime}
                                        readOnly
                                      />
                                    </div> */}
                                        {/* <div class Name="col-sm-6 form-group mb-3">
                                      <label>Resolved By</label>
                                      <input
                                        name="resolvedBy"
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={resolvedBy}
                                        readOnly
                                      />
                                    </div> */}
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {
                                    <div className="row">
                                      <div className="col-md-12 pt-1 pb-4 text-center">
                                        <Link
                                          to={"/support"}
                                          className="btn btn-secondary mr-2"
                                        >
                                          Back
                                        </Link>
                                        {/* <button
                                          type="button"
                                          className="btn btn-primary ml-2"
                                          onClick={() => {
                                            this.updateInfoForClose();
                                          }}
                                        >
                                          Close qwer
                                        </button> */}
                                      </div>
                                    </div>
                                  }
                                </form>
                              )
                            }
                            {this.state.reassignClicked ? (
                              <form onSubmit={this.onSubmit}>
                                <div className="row">
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Status</label>
                                    <select
                                      name="isClosed"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={isClosed}
                                      disabled={true}
                                      required
                                    >
                                      <option value={2}>Not Started</option>
                                      {/* <option value={3}>Acknowledged</option> */}
                                      <option value={1}>Close</option>
                                      <option value={4}>Submitted</option>
                                      <option value={3}>Reassigned</option>
                                      <option hidden value={4}>
                                        Reopened
                                      </option>
                                    </select>
                                  </div>
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Assigned To </label>

                                    <select
                                      name="assignedTo"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={assignedTo}
                                      // disabled={SupportData.isClosed == 1}
                                    >
                                      <option value="">Select User</option>

                                      {userList &&
                                      Array.isArray(userList) &&
                                      userList.length > 0
                                        ? userList.map((userData, index) => {
                                            // console.log("console.log,userData", userData);
                                            return userData?.role?.roleLable === 6 ? (
                                              <option key={index} value={userData.id}>
                                                {userData?.firstName +
                                                  " " +
                                                  userData?.lastName}
                                              </option>
                                            ) : (
                                              ""
                                            );
                                          })
                                        : ""}
                                    </select>
                                    <span className={"small text-danger"}>
                                      {this.state?.errorForm?.assignedTo}
                                    </span>
                                  </div>
                                </div>
                                <div className="row">
                                  {
                                    <div className="col-sm-12 form-group mb-3">
                                      <label> Reassign Comments </label>
                                      <input
                                        name="commentsReassigned"
                                        type="text"
                                        placeholder="Add comments"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={this.state.commentsReassigned}
                                        //    readOnly={SupportData.isClosed == 1}
                                      />
                                    </div>
                                  }
                                </div>
                                {this.state.closed == 1 && (
                                  <React.Fragment>
                                    <div className="row">
                                      {/* <div className="col-md-12 form-group mb-3">
                                        <label>Resolution</label>
                                        <textarea
                                          name="resolution"
                                          placeholder="xyz"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolution}
                                          readOnly
                                        ></textarea>
                                      </div> */}
                                    </div>
                                    <div className="row">
                                      {/* <div className="col-sm-6 form-group mb-3 datePickerUp">
                                        <label>Date and Time of Resolution</label>

                                        <input
                                          name="resolutionDateTime"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolutionDateTime}
                                          readOnly
                                        />
                                      </div> */}
                                      {/* <div class Name="col-sm-6 form-group mb-3">
                                        <label>Resolved By</label>
                                        <input
                                          name="resolvedBy"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolvedBy}
                                          readOnly
                                        />
                                      </div> */}
                                    </div>
                                  </React.Fragment>
                                )}
                                {
                                  <div className="row">
                                    <div className="col-md-12 pt-1 pb-4 text-center">
                                      <Link
                                        to={"/support"}
                                        className="btn btn-secondary mr-2"
                                      >
                                        Back
                                      </Link>
                                      <button
                                        type="button"
                                        className="btn btn-primary ml-2"
                                        onClick={() => {
                                          this.updateInfoForReassign();
                                        }}
                                      >
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                }
                              </form>
                            ) : null}
                            {
                              // this.state.SupportData.ticketStatus === "reassigned"
                              false && (
                                <form onSubmit={this.onSubmit}>
                                  <div className="row">
                                    <div className="col-sm-6 form-group mb-3">
                                      <label>Status</label>
                                      <select
                                        name="isClosed"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={3}
                                        disabled={true}
                                        required
                                      >
                                        <option value={2}>Not Started</option>
                                        {/* <option value={3}>Acknowledged</option> */}
                                        <option value={1}>Close</option>
                                        <option value={4}>Submitted</option>
                                        <option value={3}>Reassigned</option>
                                        <option hidden value={4}>
                                          Reopened
                                        </option>
                                      </select>
                                    </div>
                                    <div className="col-sm-6 form-group mb-3">
                                      <label>Assigned To</label>

                                      <select
                                        name="assignedTo"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={assignedTo}
                                        // disabled={SupportData.isClosed == 1}

                                        required
                                      >
                                        <option value="">Select User</option>

                                        {userList &&
                                        Array.isArray(userList) &&
                                        userList.length > 0
                                          ? userList.map((userData, index) => {
                                              // console.log("console.log,userData", userData);
                                              return userData?.role?.roleLable === 6 ? (
                                                <option key={index} value={userData.id}>
                                                  {userData?.firstName +
                                                    " " +
                                                    userData?.lastName}
                                                </option>
                                              ) : (
                                                ""
                                              );
                                            })
                                          : ""}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row">
                                    {
                                      <div className="col-sm-12 form-group mb-3">
                                        <label> Reassign Comments</label>
                                        <input
                                          name="commentsReassigned"
                                          type="text"
                                          placeholder="Add comments"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={this.state.commentsReassigned}
                                          //    readOnly={SupportData.isClosed == 1}
                                        />
                                      </div>
                                    }
                                  </div>
                                  {this.state.closed == 1 && (
                                    <React.Fragment>
                                      <div className="row">
                                        {/* <div className="col-md-12 form-group mb-3">
                                        <label>Resolution</label>
                                        <textarea
                                          name="resolution"
                                          placeholder="xyz"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolution}
                                          readOnly
                                        ></textarea>
                                      </div> */}
                                      </div>
                                      <div className="row">
                                        {/* <div className="col-sm-6 form-group mb-3 datePickerUp">
                                        <label>Date and Time of Resolution</label>

                                        <input
                                          name="resolutionDateTime"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolutionDateTime}
                                          readOnly
                                        />
                                      </div> */}
                                        {/* <div class Name="col-sm-6 form-group mb-3">
                                        <label>Resolved By</label>
                                        <input
                                          name="resolvedBy"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolvedBy}
                                          readOnly
                                        />
                                      </div> */}
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {
                                    <div className="row">
                                      <div className="col-md-12 pt-1 pb-4 text-center">
                                        <Link
                                          to={"/support"}
                                          className="btn btn-secondary mr-2"
                                        >
                                          Back
                                        </Link>
                                        <button
                                          type="button"
                                          className="btn btn-primary ml-2"
                                          // onClick={() => {
                                          //   this.updateInfoForReassign();
                                          // }}
                                          onClick={() => {
                                            this.updateInfoForReassign();
                                          }}
                                        >
                                          Update
                                        </button>
                                      </div>
                                    </div>
                                  }
                                </form>
                              )
                            }
                          </React.Fragment>
                        ) : (
                          <p></p>
                        )}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="chattingSec">
                        <div className="mesgs">
                          <div
                            ref={(el) => {
                              this.messagesContainer = el;
                            }}
                            className="msg_history ticketViewChats"
                          >
                            {chatList && chatList.length > 0 ? (
                              chatList.map((chat) => {
                                let viewType = "";
                                let size;
                                if (chat.document?.extenstion === ".mp4") {
                                  viewType = "video";
                                }
                                if (chat.document?.extenstion === ".pdf") {
                                  viewType = "document";
                                  size = 25;
                                }
                                if (chat.userId == this.props.user.user.id) {
                                  return (
                                    <div className="outgoing_msg">
                                      <div className="sent_msg">
                                        <span className="time_date">
                                          <span className="reciver_name">
                                            {chat.user
                                              ? chat.user.firstName +
                                                " " +
                                                chat.user.lastName
                                              : ""}
                                          </span>
                                          <span style={{ paddingLeft: "4px" }}>
                                            {chatDateFormat(chat.createdAt)}
                                          </span>
                                        </span>

                                        <p>{chat.message}</p>
                                        <div>
                                          {chat.document && (
                                            <>
                                              <EvidencePreview
                                                file={chat.document}
                                                type={viewType}
                                                size={size}
                                              />
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="incoming_msg">
                                      <div className="incoming_msg_img">
                                        <img
                                          src={
                                            chat.user && chat.user.document
                                              ? URL_CONFIG.DEV_URL +
                                                "uploads/" +
                                                chat.user.document.document_name
                                              : "https://ptetutorials.com/images/user-profile.png"
                                          }
                                          alt="img"
                                        />
                                      </div>

                                      <div className="received_msg">
                                        <div className="received_withd_msg">
                                          <span className="time_date">
                                            <span className="reciver_name">
                                              {chat.user
                                                ? chat.user.firstName +
                                                  " " +
                                                  chat.user.lastName
                                                : ""}{" "}
                                            </span>
                                            <span style={{ paddingLeft: "4px" }}>
                                              {chatDateFormat(chat.createdAt)}
                                            </span>
                                          </span>
                                          <p>{chat.message}</p>
                                          {/* <p>{"Document"}</p> */}
                                          <div>
                                            {chat.document && (
                                              <>
                                                <EvidencePreview
                                                  file={chat.document}
                                                  type={viewType}
                                                  size={size}
                                                />
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })
                            ) : (
                              <p></p>
                            )}
                            {/* <div className="incoming_msg">
                                                        <div className="incoming_msg_img"> <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil" /> </div>
                                                        <div className="received_msg">
                                                            <div className="received_withd_msg">
                                                                <p>By using the HTML canvas API and some basic math we build a tiny crop helper function that makes it easy to quickly crop images in various aspect ratios. This helps us prepare images for social media posts, profile pictures, familiar document sizes, or other popular media formats.</p>
                                                                <span className="time_date"> 11:01 AM    |    June 9</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="outgoing_msg">
                                                        <div className="sent_msg">
                                                            <p>Test which is a new approach to have all
solutions</p>
                                                            <span className="time_date"> 11:01 AM    |    June 9</span> </div>
                                                    </div> */}
                          </div>
                          {this.state.SupportData.ticketStatus === "closed" ? (
                            <></>
                          ) : this.state.SupportData.ticketStatus === "inProgress" ? (
                            this.state?.SupportData?.createdBy ===
                              this.props.user.user.id ||
                            this.state?.SupportData?.startedBy ===
                              this.props.user.user.id ||
                            this.state.roleLabel === 1 ? (
                              <div className="type_msg">
                                <form onSubmit={this.sendMessage}>
                                  <div className="input_msg_write">
                                    <div className="uploadFileBtn">
                                      <label htmlFor="upload-single-file">
                                        <BsFileEarmarkArrowUp />
                                      </label>
                                      <input
                                        className="uploadFile"
                                        type="file"
                                        onChange={this.onChangeHandler}
                                      />
                                    </div>
                                    <div>
                                      <span style={{ width: "35%" }}>
                                        {this.state.fileResponse && (
                                          <EvidencePreview
                                            file={this.state.fileResponse.file}
                                            type={this.state.fileResponse.type}
                                            size={this.state.fileResponse.size}
                                          />
                                        )}
                                      </span>
                                    </div>
                                    <textarea
                                      name="message"
                                      type="text"
                                      className="write_msg"
                                      placeholder="Add Comment"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={message}
                                      maxlength="250"
                                      required
                                    ></textarea>
                                    <div className="actionBtns">
                                      {/* <button
                                                                className="msg_send_btn"
                                                                type="button"
                                                            ><GrAttachment /></button> */}
                                      <button className="sendBtn" type="submit">
                                        <span>Submit</span> <IoIosArrowRoundForward />
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            ) : (
                              <></>
                            )
                          ) : this.state.SupportData.ticketStatus === "reassigned" ||
                            this.state.SupportData.ticketStatus === "reOpened" ? (
                            this.state?.SupportData?.assignedTo ===
                              this.props.user.user.id ||
                            this.state?.SupportData?.createdBy ===
                              this.props.user.user.id ||
                            this.state.roleLabel === 1 ? (
                              <div className="type_msg">
                                <form onSubmit={this.sendMessage}>
                                  <div className="input_msg_write">
                                    <div className="uploadFileBtn">
                                      <label htmlFor="upload-single-file">
                                        <BsFileEarmarkArrowUp />
                                      </label>
                                      <input
                                        className="uploadFile"
                                        type="file"
                                        onChange={this.onChangeHandler}
                                      />
                                    </div>
                                    <div>
                                      <span style={{ width: "35%" }}>
                                        {this.state.fileResponse && (
                                          <EvidencePreview
                                            file={this.state.fileResponse.file}
                                            type={this.state.fileResponse.type}
                                            size={this.state.fileResponse.size}
                                          />
                                        )}
                                      </span>
                                    </div>
                                    <textarea
                                      name="message"
                                      type="text"
                                      className="write_msg"
                                      placeholder="Add Comment"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={message}
                                      maxlength="250"
                                      required
                                    ></textarea>
                                    <div className="actionBtns">
                                      {/* <button
                                                              className="msg_send_btn"
                                                              type="button"
                                                          ><GrAttachment /></button> */}
                                      <button className="sendBtn" type="submit">
                                        <span>Submit</span> <IoIosArrowRoundForward />
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            ) : (
                              <></>
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col md={12}>
                      <div className="">
                        <Row>
                          <Col md={4} className="drilingView-bx">
                            <h5>Ticket No.</h5>
                            <p>
                              {this.state.SupportData && this.state.SupportData.ticket_no}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Date & Time</h5>
                            <p>
                              {this.state.SupportData &&
                                chatDateFormat(this.state.SupportData.ticket_date)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Section</h5>
                            <p>
                              {this.state.SupportData && this.state.SupportData.section}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Sub Section</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.subSection}
                            </p>
                          </Col>
                          {/* <Col md={4} className="drilingView-bx">
                          <h5>Module</h5>
                          <p>
                            {this.state.SupportData && this.state.SupportData.module_name}
                          </p>
                        </Col> */}
                          {/* <Col md={4} className="drilingView-bx">
                          <h5>Sub Modules</h5>
                          <p>
                            {this.state.SupportData &&
                              this.state.SupportData.submodule_name}
                          </p>
                        </Col> */}
                          <Col md={4} className="drilingView-bx">
                            <h5>Reported By</h5>
                            <p>
                              {createdByUser
                                ? createdByUser.firstName + " " + createdByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Ticket Status</h5>
                            <p>
                              {this.state.SupportData &&
                              this.state.SupportData.ticketStatus === "Closed"
                                ? "Closed"
                                : this.state.SupportData.ticketStatus === "reassigned"
                                ? "Re-assigned"
                                : this.state.SupportData.ticketStatus === "submitted"
                                ? "Submitted"
                                : this.state.SupportData.ticketStatus === "inProgress"
                                ? "In Progress"
                                : "Re-Opened"}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Started By</h5>
                            <p>
                              {this.state.SupportData?.startedByUser
                                ? this.state.SupportData.startedByUser.firstName +
                                  " " +
                                  this.state.SupportData.startedByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Closed By</h5>
                            <p>
                              {this.state.SupportData?.closedByUser
                                ? this.state.SupportData.closedByUser.firstName +
                                  " " +
                                  this.state.SupportData.closedByUser.lastName
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Started At</h5>
                            <p>
                              {this.state.SupportData?.startedAt &&
                                chatDateFormat(this.state.SupportData.startedAt)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Closed At</h5>
                            <p>
                              {this.state.SupportData?.closedAt &&
                                chatDateFormat(this.state.SupportData.closedAt)}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Role</h5>
                            <p>
                              {createdByUser
                                ? createdByUser.role.title
                                  ? createdByUser.role.title
                                  : ""
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Site Type</h5>
                            <p>
                              {createdByUser
                                ? createdByUser.role.siteType
                                  ? createdByUser.role.siteType
                                  : ""
                                : ""}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Priority</h5>
                            <p>
                              {this.state.SupportData &&
                                (this.state.SupportData.priority == 3
                                  ? "High"
                                  : this.state.SupportData.priority == 2
                                  ? "Medium"
                                  : "Low")}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Issue Summary</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.issue_summary}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Issue Description</h5>
                            <p>
                              {this.state.SupportData &&
                                this.state.SupportData.issue_description}
                            </p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Url From</h5>
                            <p>{SupportData.urlFrom ? SupportData.urlFrom : ""}</p>
                          </Col>
                          <Col md={4} className="drilingView-bx">
                            <h5>Attachments</h5>
                            <div className="attachedFile-bx">
                              {SupportData &&
                                SupportData.documents_table_mappings &&
                                SupportData.documents_table_mappings.map((element) => {
                                  if (element.document) {
                                    return (
                                      <p>
                                        <span>{element.document.alias}</span>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id="tooltip-top">
                                              {" "}
                                              {element.document.real_document_name}
                                            </Tooltip>
                                          }
                                        >
                                          <a
                                            href={
                                              URL_CONFIG.IMG_URL +
                                              element.document.document_name
                                            }
                                            target="_blank"
                                            className="icons text-cyanBlue"
                                            style={{ textAlign: "center" }}
                                          >
                                            <BsFileEarmarkArrowDown size="16" />
                                          </a>
                                        </OverlayTrigger>
                                      </p>
                                    );
                                  }
                                })}
                            </div>
                          </Col>
                          {/* {userList && Array.isArray(userList) && userList.length > 0
                          ? userList.map((userData, index) => {
                              return userData.id === reportedByUser.id
                                ? userData.accessPermissions.map(
                                    (accessPermission, index) => {
                                      return (
                                        <>
                                          <Col md={4} className="drilingView-bx">
                                            <h5>{accessPermission.permission}</h5>
                                            <p>
                                              {accessPermission.permissionValue == 1
                                                ? "YES"
                                                : "NO"}
                                            </p>
                                          </Col>
                                        </>
                                      );
                                    }
                                  )
                                : "";
                            })
                          : ""} */}
                          {this.state.superadmin == 0 ? (
                            <Col md={4} className="drilingView-bx">
                              <h5>Role Permission</h5>
                              <p>
                                {userList
                                  ?.find((userData) => userData?.id === createdByUser?.id)
                                  ?.accessPermissions?.filter(
                                    (d) => +d.permissionValue === 1
                                  )
                                  .map((d) => {
                                    if (createdByUser.role.siteType == 3) {
                                      return MINE_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    } else if (createdByUser.role.siteType == 2) {
                                      return RO_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    } else if (createdByUser.role.siteType == 1) {
                                      return HO_Work_Flow_Role_List?.find(
                                        (d1) => d1.name == d.permission
                                      )?.label;
                                    }
                                  })
                                  .join(", ")}
                              </p>
                            </Col>
                          ) : (
                            <></>
                          )}
                        </Row>
                        {/* {this.state.superadmin == 0 ? (
                          <React.Fragment>
                            <div className="closeTicketSec">
                              <h4>Close this ticketAnmol</h4>
                              <button
                                className="toggleTicketForm"
                                onClick={() => {
                                  this.setState({ show: !this.state.show });
                                }}
                              >
                                {this.state.show ? "Hide" : "Show"} Form
                              </button>
                            </div>
                            <div></div>

                            {this.state.show ? (
                              <form onSubmit={this.onSubmit}>
                                <div className="row">
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Status</label>
                                    <select
                                      name="isClosed"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={isClosed}
                                      disabled={SupportData.isClosed == 1}
                                      required
                                    >
                                      <option value={2}>Not Started</option>
                                      <option value={3}>Acknowledged</option>
                                      <option value={1}>Close</option>
                                      <option hidden value={4}>
                                        Reopened
                                      </option>
                                    </select>
                                  </div>
                                  <div className="col-sm-6 form-group mb-3">
                                    <label>Assigned To</label>

                                    <select
                                      name="assignedTo"
                                      className="form-control"
                                      onChange={(e) => this.handleInputChange(e)}
                                      value={assignedTo}
                                      disabled={SupportData.isClosed == 1}
                                      required
                                    >
                                      <option value="">Select User</option>

                                      {userList &&
                                      Array.isArray(userList) &&
                                      userList.length > 0
                                        ? userList.map((userData, index) => {
                                            // console.log("console.log,userData", userData);
                                            return userData?.role?.roleLable === 6 ? (
                                              <option key={index} value={userData.id}>
                                                {userData?.firstName +
                                                  " " +
                                                  userData?.lastName}
                                              </option>
                                            ) : (
                                              ""
                                            );
                                          })
                                        : ""}
                                    </select>
                                  </div>
                                </div>
                                <div className="row">
                                  {this.state.closed != 1 && (
                                    <div className="col-sm-12 form-group mb-3">
                                      <label>Comments</label>
                                      <input
                                        name="comments"
                                        type="text"
                                        placeholder="Add comments"
                                        className="form-control"
                                        onChange={(e) => this.handleInputChange(e)}
                                        value={comments}
                                        readOnly={SupportData.isClosed == 1}
                                      />
                                    </div>
                                  )}
                                </div>
                                {this.state.closed == 1 && (
                                  <React.Fragment>
                                    <div className="row">
                                      <div className="col-md-12 form-group mb-3">
                                        <label>Resolution</label>
                                        <textarea
                                          name="resolution"
                                          placeholder="xyz"
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolution}
                                          readOnly
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-6 form-group mb-3 datePickerUp">
                                        <label>Date and Time of Resolution</label>

                                        <input
                                          name="resolutionDateTime"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolutionDateTime}
                                          readOnly
                                        />
                                      </div>
                                      <div class Name="col-sm-6 form-group mb-3">
                                        <label>Resolved By</label>
                                        <input
                                          name="resolvedBy"
                                          type="text"
                                          placeholder=""
                                          className="form-control"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={resolvedBy}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )}
                                {SupportData.isClosed != 1 && (
                                  <div className="row">
                                    <div className="col-md-12 pt-1 pb-4 text-center">
                                      <Link
                                        to={"/support"}
                                        className="btn btn-secondary mr-2"
                                      >
                                        Back
                                      </Link>
                                      <button className="btn btn-primary ml-2">
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </form>
                            ) : null}
                          </React.Fragment>
                        ) : (
                          <p></p>
                        )} */}
                      </div>
                    </Col>
                  </Row>
                )}
                {/* <LocationHistoryList data={[]} getFormData={[]} siteList={[]} /> */}
                <div className="mt-4 text-center">
                  <span
                    className="btn btn-secondary mx-2"
                    onClick={() => this.props.history?.goBack()}
                  >
                    Go Back
                  </span>
                </div>

                {this.state?.SupportData?.ticket?.length > 0 && (
                  <SupportHistoryTable
                    ticket={this.state.SupportData.ticket}
                  ></SupportHistoryTable>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <LogHistory
          subModulename={"support"}
          refrenceId={this.state.supportId}
        ></LogHistory> */}
      </div>
    );
  }
}

// export default TicketView
const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TicketView);
